// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"base-station"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12ZM12 12V22","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M4.92991 3.92969C1.02467 7.83493 1.02467 14.1666 4.92991 18.0718M8.1114 7.11133C5.96352 9.25921 5.96352 12.7416 8.1114 14.8895M15.8887 7.11133C18.0366 9.25921 18.0366 12.7416 15.8887 14.8895M19.0703 3.92969C22.9756 7.83493 22.9756 14.1666 19.0703 18.0718","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-base-station')
export default class BaseStationIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'base-station',
    }
  }
}
